import { useContext, useEffect } from 'react';
import { GlobalContext } from '../../../library/Core/GlobalContext';
import { useLoaderData } from 'react-router-dom';
import { useImmerReducer } from 'use-immer';
import { DispatchEvent, State } from '../../../library/Core/SmartTypes';
import smartReducer from '../../../library/Core/SmartReducer';
import { SmartContext } from '../../../library/Core/SmartContext';
import DebugBarControl from '../../../library/SimpleControls/DebugBarControl';
import UpdateAlumniLayout from './UpdateAlumniLayout';
import PageBuilder from '../../../library/Builders/PageBuilder/PageBuilder';

const UpdateAlumni = () => {
    const { globalState } = useContext(GlobalContext);

    const [state, dispatch] = useImmerReducer<State, DispatchEvent>(smartReducer, {
        flags: { isDataLoading: true, showFormErrors: 0 },
        formValidationErrors: {},
        actions: {},
    } as any);

    const { formConfig, data, internal, routeInfo } = useLoaderData() as State;
    useEffect(() => {
        dispatch({
            type: 'DATA_INIT',
            payload: { formConfig, data, domain: new Map([...globalState.domain]), internal, routeInfo },
        });
    }, [data]);

    return (
        <SmartContext.Provider value={{ state, dispatch }}>
            <DebugBarControl />
            {!state.flags.isDataLoading && (
                <UpdateAlumniLayout>
                    {!state.flags.isDataLoading && <PageBuilder />}
                </UpdateAlumniLayout>
            )}
        </SmartContext.Provider>
    );
};

export default UpdateAlumni;
